<template>
  <div class="shell">
    <header class="top">
      <div class="brand">星河宸镜</div>
      <button class="icon-btn" type="button" aria-label="收起菜单" @click="collapsed = !collapsed">
        <i class="el-icon-s-fold" />
      </button>
      <div class="crumb">{{ groupName }} <span>›</span> {{ pageTitle }}</div>
      <label class="search">
        <i class="el-icon-search" />
        <input v-model="keyword" placeholder="搜索渠道 / 账号" @keyup.enter="search" />
      </label>
      <button class="logout" type="button" @click="$router.push('/admin/dashboard')">官网后台</button>
      <div class="who">
        <span class="avatar">{{ initial }}</span>
        <span class="who-text">
          <b>{{ displayName }}</b>
          <small>总后台</small>
        </span>
        <button class="logout" type="button" @click="logout">退出</button>
      </div>
    </header>
    <div class="body">
      <aside :class="{ collapsed }">
        <nav>
          <section v-for="group in groups" :key="group.name">
            <p class="group">{{ group.name }}</p>
            <router-link v-for="item in group.items" :key="item.path" :to="item.path" class="item">
              <i :class="item.icon" />
              <span>{{ item.label }}</span>
            </router-link>
          </section>
        </nav>
      </aside>
      <main ref="main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const GROUPS = [
  {
    name: '经营总览',
    paths: ['/hq/board', '/hq/stats'],
    items: [
      { label: '工作台看板', path: '/hq/board', icon: 'el-icon-data-board' },
      { label: '渠道统计', path: '/hq/stats', icon: 'el-icon-pie-chart' }
    ]
  },
  {
    name: '渠道',
    paths: ['/hq/partners', '/hq/accounts'],
    items: [
      { label: '渠道管理', path: '/hq/partners', icon: 'el-icon-share' },
      { label: '渠道账号', path: '/hq/accounts', icon: 'el-icon-user' }
    ]
  },
  {
    name: '资金',
    paths: ['/hq/wallet', '/hq/eco-recharges', '/hq/settlements', '/hq/deposits', '/hq/vouchers', '/hq/point-recharges'],
    items: [
      { label: '资金与积分账户', path: '/hq/wallet', icon: 'el-icon-wallet' },
      { label: '生态充值审核', path: '/hq/eco-recharges', icon: 'el-icon-s-check' },
      { label: '分账结算', path: '/hq/settlements', icon: 'el-icon-document-checked' },
      { label: '保证金管理', path: '/hq/deposits', icon: 'el-icon-coin' },
      { label: '代金券管理', path: '/hq/vouchers', icon: 'el-icon-bank-card' },
      { label: '积分充值清单', path: '/hq/point-recharges', icon: 'el-icon-tickets' }
    ]
  },
  {
    name: '规则与合规',
    paths: ['/hq/policies', '/hq/agreements', '/hq/training', '/hq/reports', '/hq/profile-changes', '/hq/alerts'],
    items: [
      { label: '政策配置', path: '/hq/policies', icon: 'el-icon-setting' },
      { label: '协议管理', path: '/hq/agreements', icon: 'el-icon-document' },
      { label: '培训管理', path: '/hq/training', icon: 'el-icon-reading' },
      { label: '报备审核', path: '/hq/reports', icon: 'el-icon-s-check' },
      { label: '资料变更审核', path: '/hq/profile-changes', icon: 'el-icon-edit-outline' },
      { label: '订单预警', path: '/hq/alerts', icon: 'el-icon-warning-outline' }
    ]
  }
]

export default {
  name: 'HqLayout',
  data() {
    return { collapsed: false, keyword: '', groups: GROUPS }
  },
  computed: {
    ...mapGetters(['adminInfo']),
    displayName() {
      if (!this.adminInfo) return '管理员'
      return this.adminInfo.realName || this.adminInfo.username || '管理员'
    },
    initial() {
      return (this.displayName || '管').slice(0, 1)
    },
    pageTitle() {
      return (this.$route.meta && this.$route.meta.menuName) || '代理商管理后台'
    },
    groupName() {
      const hit = GROUPS.find(group => group.paths.indexOf(this.$route.path) >= 0)
      return hit ? hit.name : '经营总览'
    }
  },
  watch: {
    pageTitle: {
      immediate: true,
      handler(title) {
        document.title = title + ' · 星河宸镜'
      }
    },
    '$route.path'() {
      this.$nextTick(() => {
        if (this.$refs.main) this.$refs.main.scrollTop = 0
      })
    }
  },
  methods: {
    ...mapActions(['adminLogout']),
    search() {
      const keyword = this.keyword.trim()
      if (!keyword) return
      this.$router.push({ path: '/hq/partners', query: { keyword } })
    },
    logout() {
      this.adminLogout()
      this.$router.replace('/admin/login')
    }
  }
}
</script>

<style>
@import '../partner/partner-ui.css';
</style>

<style scoped>
.shell { height: 100vh; display: flex; flex-direction: column; background: #f3f5fb; color: #1f2a44; }
.top { height: 56px; flex: none; display: flex; align-items: center; gap: 14px; padding: 0 18px; background: #1e2a78; color: #fff; }
.brand { font-size: 16px; font-weight: 700; letter-spacing: 1px; min-width: 88px; }
.icon-btn, .logout { border: 0; background: transparent; color: #fff; cursor: pointer; font-size: 16px; }
.logout { font-size: 12px; opacity: .9; }
.crumb { font-size: 13px; color: rgba(255,255,255,.85); white-space: nowrap; }
.crumb span { margin: 0 6px; opacity: .6; }
.search { margin-left: auto; display: flex; align-items: center; gap: 8px; width: 240px; height: 34px; padding: 0 12px; border-radius: 17px; background: rgba(255,255,255,.12); color: rgba(255,255,255,.7); }
.search input { flex: 1; border: 0; outline: none; background: transparent; color: #fff; font-size: 13px; }
.search input::placeholder { color: rgba(255,255,255,.55); }
.who { display: flex; align-items: center; gap: 8px; }
.avatar { width: 32px; height: 32px; border-radius: 50%; background: #f0b429; color: #1e2a78; font-weight: 700; display: flex; align-items: center; justify-content: center; }
.who-text { display: flex; flex-direction: column; line-height: 1.2; }
.who-text b { font-size: 13px; }
.who-text small { font-size: 11px; color: rgba(255,255,255,.7); }
.body { flex: 1; min-height: 0; display: flex; }
aside { width: 220px; flex: none; background: #1a2468; color: #d5dcf5; overflow: auto; }
aside.collapsed { width: 0; overflow: hidden; }
nav { padding: 12px 0 24px; }
.group { margin: 14px 18px 6px; font-size: 12px; color: rgba(213,220,245,.45); }
.item { width: 100%; display: flex; align-items: center; gap: 10px; padding: 10px 18px; color: #d5dcf5; text-decoration: none; font-size: 14px; box-sizing: border-box; }
.item.router-link-active { background: rgba(255,255,255,.08); color: #fff; box-shadow: inset 3px 0 0 #f0b429; }
main { flex: 1; min-width: 0; overflow: auto; padding: 20px 24px 32px; }
</style>
